import { render, staticRenderFns } from "./WatchListWidget.vue?vue&type=template&id=d59d3dae&"
import script from "./WatchListWidget.vue?vue&type=script&lang=js&"
export * from "./WatchListWidget.vue?vue&type=script&lang=js&"
import style0 from "./WatchListWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports